function sanitizeCsvField(value: unknown): string {
    const stringValue = value === null || value === undefined ? '' : String(value);
    return stringValue.replace(/\r\n|\r|\n/g, ' ').trim();
}

// Quotes a field (RFC 4180 style) if it contains a comma or quote.
export function escapeCsvField(value: unknown): string {
    const sanitized = sanitizeCsvField(value);
    if (sanitized.includes(',') || sanitized.includes('"')) {
        return `"${sanitized.replace(/"/g, '""')}"`;
    }
    return sanitized;
}

export function buildCsvRow(values: unknown[]): string {
    return values.map(escapeCsvField).join(',') + '\n';
}
